import React, { useState } from 'react'
import styled from 'styled-components'

import { palette, fonts } from '../../styles/variables'
import { PrimaryButton, CloseButton } from '../buttons/Buttons'
import { translate } from '../../utils/translation'
import { Text } from '../topography'
import Icon from '../icon/Icon'
import leftBanner from '../../styles/assets/atp/left_banner.png'
import annIcon from '../../styles/assets/atp/ann.svg'
import chartIcon from '../../styles/assets/atp/chart.svg'
import starIcon from '../../styles/assets/atp/star.svg'
import greyQuestionIcon from '../../styles/assets/atp/question_grey.svg'
import satisfiedUsersImage from '../../styles/assets/atp/satisfied_users.png'
import greySearchIcon from '../../styles/assets/atp/search_grey.svg'
import doubleQuotesIcon from '../../styles/assets/atp/double_quotes.svg'
import { LoadingWheel } from '../loading/Loading'
import { Box } from '../boxes/Boxes'
import { getLoggedUser } from '../../utils/userAuth'

import Modal, { ModalContent } from './Modal'

const desktopStyle = {
  width: 'fit-content',
  borderRadius: 0,
  margin: 'auto',
  overflow: 'auto',
  maxHeight: 'calc(100vh - 100px)',
}

const overlayStyle = {
  maxHeight: '100vh',
  alignItems: 'initial',
  justifyContent: 'initial',
  padding: '50px',
  zIndex: 20001,
}

const ModalContentWrapper = styled(ModalContent)({
  width: '1308px',
  maxWidth: '1308px',
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
  padding: '0px',
  margin: '0px',
})

const ImageWrapper = styled.div({
  width: 330,
  backgroundImage: `url(${leftBanner})`,
  backgroundSize: '100% 100%',
  backgroundRepeat: 'no-repeat',
})

const RightWrapper = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '48px',
})

const OffersWrapper = styled.div({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  margin: '34px 0',
  gap: '48px',
})

const OfferWrapper = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
})

const ReviewWrapper = styled.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  background: palette.lightGray10,
})

const AnnReviewWrapper = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  margin: '32px',
  zIndex: 1,
})

const AnnWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  margin: '20px 0 0',
  alignItems: 'center',
})

const AnnInfoWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  margin: '0 0 0 12px',
})

const ReviewUsersWrapper = styled.div({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  background: `linear-gradient(90deg, ${palette.lightGray20} 100%, ${palette.lightGray30} 100%)`,
})

const UsersWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '0 24px',
})

const RightBottomWrapper = styled.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  margin: '22px 0 0',
})

const ComparedMonthlySubscriptionWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
})

const LimitedOfferWrapper = styled.div({
  position: 'absolute',
  left: 24,
  top: 13,
})

const OfferButton = styled(PrimaryButton)({
  width: '100%',
  height: '56px',
  margin: '6px 0 0px',
  fontSize: '16px',
  fontWeight: '500',
  lineHeight: '16px',
  letterSpacing: '1.12px',
  color: palette.white,
  background: palette.blue,
  border: palette.blue,
  '&:hover': {
    backgroundColor: palette.deepBlue,
  },
})

export default ({ isOpen, onAccept, onDeny }) => {
  const user = getLoggedUser()
  const [isLoading, setIsLoading] = useState(false)

  const Offers = [
    {
      icon: greyQuestionIcon,
      title: translate('uncover_questions'),
      content: translate('uncover_questions_subheading'),
    },
    {
      icon: greySearchIcon,
      title: translate('match_intent'),
      content: translate('match_intent_subheading'),
    },
    {
      icon: chartIcon,
      title: translate('outsmart_competitors'),
      content: translate('outsmart_competitors_subheading'),
    },
  ]

  return (
    <Modal
      isOpen={isOpen && !user?.subscription?.bfATPPromoClaimed}
      desktopStyle={desktopStyle}
      overlayStyle={overlayStyle}
    >
      <ModalContentWrapper>
        <ImageWrapper />
        <RightWrapper>
          <CloseButton
            onClick={() => {
              setIsLoading(false)
              onDeny()
            }}
            styles={{ top: '20px' }}
          />
          <Box
            style={{
              border: 0,
              minHeight: 0,
              position: 'absolute',
              top: '19px',
              right: '19px',
              margin: 0,
              padding: 0,
              backgroundColor: 'inherit',
            }}
          >
            {isLoading && <LoadingWheel width="26px" height="26px" />}
          </Box>
          <Text
            padding="8px 7px"
            fontSize="14px"
            fontFamily={fonts.primary}
            textAlign="center"
            color={palette.darkGray}
            style={{
              width: 'fit-content',
              background: palette.dullGreen,
              border: `1px solid ${palette.green}`,
              borderRadius: '2px',
            }}
          >
            {translate('exclusive_offer').toUpperCase()}
          </Text>
          <Text
            margin="22px 0 0"
            fontSize="35px"
            lineHeight="1.2em"
            fontFamily={fonts.primaryMedium}
            textAlign="center"
            color={palette.darkGray}
            dangerouslySetInnerHTML={{
              __html: translate('unlock_atp_heading'),
            }}
          />
          <Text
            margin="8px 0 0"
            fontSize="14px"
            lineHeight="1.5em"
            fontFamily={fonts.primary}
            textAlign="center"
            color={palette.darkGray}
            dangerouslySetInnerHTML={{
              __html: translate('unlock_atp_subheading'),
            }}
          />
          <OffersWrapper>
            {Offers.map((offer, index) => (
              <OfferWrapper key={offer.title} order={index}>
                <Icon src={offer.icon} size="42px" />
                <Text
                  margin="17px 0 9px"
                  fontSize="14px"
                  lineHeight="1.25em"
                  fontFamily={fonts.primaryMedium}
                  textAlign="center"
                  color={palette.darkGray}
                >
                  {offer.title}
                </Text>
                <Text
                  fontSize="12px"
                  lineHeight="1.5em"
                  fontFamily={fonts.primary}
                  textAlign="center"
                  color={palette.darkGray}
                >
                  {offer.content}
                </Text>
              </OfferWrapper>
            ))}
          </OffersWrapper>
          <ReviewWrapper>
            <Icon
              style={{ position: 'absolute', top: 24, left: 24 }}
              src={doubleQuotesIcon}
              width="42px"
              height="36px"
            />
            <AnnReviewWrapper>
              <Text
                fontSize="16px"
                lineHeight="1.5em"
                fontFamily={fonts.primary}
                color={palette.darkGray}
              >
                {translate('atp_review')}
              </Text>
              <AnnWrapper>
                <Icon src={annIcon} size="40px" />
                <AnnInfoWrapper>
                  <Text
                    fontSize="14px"
                    lineHeight="1.5em"
                    fontFamily={fonts.primary}
                    color={palette.darkGray}
                  >
                    {translate('ann_handley')}
                  </Text>
                  <Text
                    fontSize="11px"
                    lineHeight="1.5em"
                    fontFamily={fonts.primary}
                    color={palette.darkGray}
                  >
                    {translate('marketing_expert')}
                  </Text>
                </AnnInfoWrapper>
              </AnnWrapper>
            </AnnReviewWrapper>
            <ReviewUsersWrapper>
              <UsersWrapper>
                <img
                  src={satisfiedUsersImage}
                  alt="No satisfied users"
                  width={102}
                  height={46}
                />
                <Text
                  margin="22px 0 0"
                  fontSize="21px"
                  lineHeight="1em"
                  fontFamily={fonts.primaryMedium}
                  color={palette.darkGray}
                >
                  {translate('two_million')}
                </Text>
                <Text
                  margin="10px 0 0"
                  fontSize="18px"
                  lineHeight="1.5em"
                  fontFamily={fonts.primary}
                  color={palette.darkGray}
                >
                  {translate('satisfied_users')}
                </Text>
              </UsersWrapper>
            </ReviewUsersWrapper>
          </ReviewWrapper>
          <RightBottomWrapper>
            <ComparedMonthlySubscriptionWrapper>
              <Text
                fontSize="21px"
                lineHeight="1.5em"
                fontFamily={fonts.primaryMedium}
                color={palette.orange}
              >
                {translate('save_ninety')}
              </Text>
              <Text
                margin="0 0 0 12px"
                fontSize="16px"
                lineHeight="1em"
                fontFamily={fonts.primary}
                color={palette.primary}
              >
                {translate('compares_monthly')}
              </Text>
            </ComparedMonthlySubscriptionWrapper>
            <OfferButton tag={translate('get_atp_offer')} onClick={onAccept} />
            <Text
              margin="6px 0 0"
              fontSize="12px"
              lineHeight="1.5em"
              fontFamily={fonts.primary}
              color={palette.darkGray}
            >
              {translate('deal_ends')}
            </Text>
            <LimitedOfferWrapper>
              <Icon className="rotating" src={starIcon} size={112} />
              <Text
                fontSize="15px"
                textAlign="center"
                fontFamily={fonts.primaryMedium}
                color={palette.white}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%) rotate(-15deg)',
                  wordBreak: 'normal',
                }}
              >
                {translate('limited_offer')}
              </Text>
            </LimitedOfferWrapper>
          </RightBottomWrapper>
        </RightWrapper>
      </ModalContentWrapper>
    </Modal>
  )
}
